
import {Component, Vue} from 'vue-property-decorator';
import CoordPicker from "@/components/CoordPicker.vue";
import {dictApi, mechanismApi, qiChaChaApi, userApi} from "@/api/organization";
import {baseUrl, imageUrl} from "@/constants";
import { ElLoadingComponent } from 'element-ui/types/loading';

const {regionData} = require("@/js/region/region");

@Component({
  components: {CoordPicker}
})
export default class Home extends Vue {
  screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
  active = 0;// 步距计数
  regionData = regionData; //区域信息
  levels = [];// 单位等级
  baseUrl = baseUrl;
  imageUrl = imageUrl;
  mechanismTypeList = []; //单位类型
  ocrIdCardFinish = false; //识别身份证号
  ocrLicenseFinish = false; //识别营业执照
  bizToken = ""; //人脸核身Token
  registStatus = 0; // 人脸核身接口返回状态
  registMsg = ""; //人脸核身返回结果
  docType = "";//证书类型
  mechanismData = {
    types: [] as any, //单位类别数组
    type: '', //单位类别
    level: '', //级别
    code: '', //统一社会信用代码
    loginName: '',//登陆用户名
    name: '', //机构名称
    regions: [], //所在区域数组
    region: '', //所在区域
    residence: '', //单位注册地址
    userName: '', //法人代表/负责人
    location: '', //经纬度坐标
    postalAddress: '', //通讯地址
    executiveDirector: '', //主管单位名字
    license: '',//执照
    corporate: '', //法人证书
    vcode: '',//验证码
    token: '', //短信验证码签名串
    idCard: '', //被委托人身份证号码
    clientName: '', //被委托人姓名
    avatar: '',//单位管理员头像
    idCardUp: '',//被委托人身份证头像面复印件
    idCardDown: '',//被委托人身份证国徽面复印件
    //用户名
    landline: '',//联系人座机电话
    templatePowerAttorney: '',//授权证书模板
    isAgree: false, //委托人与法人一致
    empower: '',//授权委托书
    userMobile: '', //联系人手机号码
  }

  empowerDialog = {
    visible: false,
    filePath: ''
  }
  map = {
    visible: false,
  }
  isSend = true //发送验证码
  smsInterval = "点击获取验证码"
  // 验证身份证
  checkIdCard = (rule: any, value: any, cb: any) => {
    if (value.length == 18) {
      cb();
    } else {
      cb(new Error('清输入合法的身份证号码!'))
    }
  }
  // 验证 信用代码
  checkCode = (rule: any, value: any, cb: any) => {
    if (value.length > 0) {
        mechanismApi.checkLoginUserName({code: value}).then((r) => {
          if (r.data.result === 0) {
            cb();
          } else {
            cb(new Error(r.data.message))
          }
        });
    } else {
      cb(new Error('请输入'))
    }
  }
  checkName = (rule: any, value: any, cb: any) => {
    if (value.length > 0) {
      if(value.includes('*')){
        cb(new Error('请您使用营业执照上的经营者名称注册，单位名称至少4个字符，例如：个体工商户张力'));
        return;
      }
      mechanismApi.checkOrgNameRepeat({orgName: value}).then((r) => {
        if (r.data.result === 0) {
          cb();
        } else {
          cb(new Error(r.data.message))
        }
      });
    } else {
      cb(new Error('请输入'))
    }
  }
  // 验证授权证书
  checkCorporate = (rule: any, value: any, cb: any) => {
    if (value.length > 0) {
      cb();
    } else {
        cb(new Error('请上传!'));
    }
  }
  // 验证名称是否重复
  checkLoginUserName = (rule: any, value: any, cb: any) => {
      mechanismApi.checkLoginUserName({loginName: value}).then((r) => {
        if (r.data.result === 0) {
          cb();
        } else {
          cb(new Error(r.data.message))
        }
      });
  }

  rules = {
    types: [{required: true, message: "请选择单位类别", trigger: "blur"}],
    level: [{required: true, message: "请选择单位级别", trigger: "blur"}],
    code: [{required: true, validator: this.checkCode, trigger: 'blur'}], //[{required: true, message:  ? '请输入统一社会信用代码' : '请输入授权证书号' , trigger: "blur"}],
    loginName: [{required: true, message: "请输入登陆用户名", trigger: "blur"}, {
      validator: this.checkLoginUserName,
      trigger: 'blur'
    }],
    name: [{required: true, validator: this.checkName, trigger: "blur"}],
    regions: [{required: true, message: "请选择所在区域", trigger: "blur"}],
    residence: [{required: true, message: "请输入单位注册地址", trigger: "blur"}],
    userName: [{required: true, message: "请输入法人代表/负责人", trigger: "blur"}],
    location: [{required: true, message: "请选择地理信息,经纬度坐标", trigger: "blur"}],
    postalAddress: [{required: true, message: "请输入通讯地址", trigger: "blur"}],
    license: [{required: true, message: "请输入主管单位", trigger: "blur"}],
    executiveDirector: [{required: true, message: "请上传主管单位营业执照", trigger: "blur"}],
    corporate: [{required: true, validator: this.checkCorporate, trigger: 'blur'}],
    vcode: [{required: true, message: "请输入短信验证码", trigger: "blur"}],
    clientName: [{required: true, message: "请输入被委托人姓名", trigger: "blur"}],
    avatar: [{required: true, message: "请上传单位管理员头像", trigger: "blur"}],
    idCardDown: [{required: true, message: "请上传被委托人身份证国徽面复印件", trigger: "blur"}],
    idCardUp: [{required: true, message: "请上传被委托人身份证头像面复印件", trigger: "blur"}],
    // landline: [{required: true, message: "请输入联系人座机电话", trigger: "blur"}],
    empower: [{required: true, message: "请上传授权委托书", trigger: "blur"}],
    landline: [{required: true, message: "请输入单位联系电话", trigger: "blur"}],
    userMobile: [{required: true, message: "请输入联系人手机号", trigger: "blur"}],
    idCard: [{required: true, message: "请输入被委托人身份证号码", trigger: "blur"}, {
      validator: this.checkIdCard,
      trigger: 'blur'
    }]
  }

  private QRCode: any;

  created() {
    console.log("123")
    if (this.$route.query.types) {
      const types = this.$route.query.types as string;
      this.mechanismData.types = types.split(',');
    }
    if(this.$route.query.docType) {
      const docType = this.$route.query.docType as string;
      this.docType = docType;
    }
    this.listDict();
  }

  formValidate(callback: any){
    let form = this.$refs.form as HTMLFormElement;
    debugger;
    form.validate((valid: any) => {
      if (valid) {
        callback();
      }
    });
  }

  startOcrIdCard(){
    this.formValidate(() => {
      userApi.getIdCardInfo(this.mechanismData.idCardUp, "REGISTER_COMPANY").then((r) => {
        if(r.data.result === 0){
          const {idNum, name} = r.data.data;
          this.mechanismData.idCard = idNum;
          this.mechanismData.clientName = name;
          this.ocrIdCardFinish = true;
        }
      })
    });
  }


  listDict() {
    //单位级别
    dictApi.listDictItem({typeCode: "dwjb"}).then((r) => {
      if (r.data.result === 0) {
        this.levels = r.data.data;
      }
    });
    //单位类别
    dictApi.listDictItem({typeCode: "dwlb"}).then((r) => {
      if (r.data.result === 0) {
        this.mechanismTypeList = r.data.data;
      }
    });
  }
  //上一个
  prevStep() {
    this.active--;
    this.$nextTick(() => {
      let form = this.$refs.form as HTMLFormElement;
      form.validate();
    });
  }
  ocrImage(){
    return new Promise((resolve) => {
      const loading = this.$loading({
        text: '正在识别',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if(this.docType === "FRZS"){
        mechanismApi.ocrSmartStructural(this.mechanismData.corporate, "法人证书","统一社会信用代码,名称,法定代表人,住所", false).then((r: any) => {
          const {data, result} = r.data;
          if (result === 0) {
            this.mechanismData.code = data['统一社会信用代码'] ? data['统一社会信用代码'] : '';
            this.mechanismData.loginName = data['统一社会信用代码'] ? data['统一社会信用代码'] : '';
            this.mechanismData.name = data['名称'] ? data['名称'] : '';
            this.mechanismData.residence = data['住所'] ? data['住所'] : '';
            this.mechanismData.userName = data['法定代表人'] ? data['法定代表人'] : '';
            this.ocrLicenseFinish = true;
            resolve({});
          }
        }).finally(() => {
          loading?.close();
        });
      }else if(this.docType === "YYZZ"){
        mechanismApi.ocrLicense(this.mechanismData.corporate, false).then((r: any) => {
          const {data, result} = r.data;
          if (result === 0) {
            this.mechanismData.code = data.regNum;
            this.mechanismData.loginName = data.regNum;
            this.mechanismData.name = data.name;
            this.mechanismData.residence = data.address;
            this.mechanismData.userName = data.person;
            this.ocrLicenseFinish = true;
            resolve({});
          }
        }).finally(() => {
          loading?.close();
        });
      }else{
        loading.close();
        this.$message.error("未识别到证书类型，请返回重新选择！");
        resolve({});
      }
    })

  }
  //下一个
  nextStep() {
    this.formValidate(() => {
      if (this.active === 0) {
        //如果识别过，并且机构代码不是空值，则直接跳出
        if(this.ocrLicenseFinish){
          this.active = 1;
          return;
        }
        this.ocrImage().then(() => {
          this.active = 1;
        });
      }else if(this.active === 1){
        this.active = 2;
      }else if(this.active === 2){
        if(!this.ocrIdCardFinish){
          this.$message.warning("请先识别身份证信息！");
          return;
        }
        this.checkVerifyUI(() => {
          this.detectAuth((url: string) => {
            this.active = 3;
            this.$nextTick(() => {
              new this.QRCode(document.getElementById("mobileImg"), {
                width: 254,
                height: 254,
                text: url
              });
            });
          });
        })
      }else if(this.active === 3){
        this.queryResult();
      }
    });
  }


  getRegisterData() {
      const mechanismData = this.mechanismData;
      mechanismData.level = (mechanismData.types.indexOf('0001') > -1 || mechanismData.types.indexOf('0002') > -1) ? mechanismData.level : ''
      mechanismData.type = "," + mechanismData.types.join(",") + ",";
      const data = {
        mechanism: {
          code: mechanismData.code,
          //单位类别
          type: mechanismData.type,
          //单位级别
          level: mechanismData.level,
          //单位名称
          name: mechanismData.name,
          //单位所属区域
          region: mechanismData.region,
          //单位注册地址
          residence: mechanismData.residence,
          //法人代表/负责人
          userName: mechanismData.userName,
          //手机号
          userMobile: mechanismData.userMobile,
          //单位地理位置
          location: mechanismData.location,
          //单位通讯地址
          postalAddress: mechanismData.postalAddress,
          //法人证书
          corporate: mechanismData.corporate,
          //授权证书
          empower: mechanismData.empower,
          //主管单位名字
          executiveDirector: mechanismData.executiveDirector,
          //执照
          license: mechanismData.license,
          //单位曾用名
          originalName: [],
          //被委托人身份证头像面复印件
          cardUp: mechanismData.idCardUp,
          //被委托人身份证国徽面复印件
          cardDown: mechanismData.idCardDown,
          //联系人座机号
          landline: mechanismData.landline,
        },
        user: {
          //被委托人身份证号码
          idCard: mechanismData.idCard,
          //被委托人姓名
          name: mechanismData.clientName,
          //单位管理员头像
          avatar: mechanismData.avatar,
          //被委托人身份证头像面复印件
          idCardUp: mechanismData.idCardUp,
          //被委托人身份证国徽面复印件
          idCardDown: mechanismData.idCardDown,
          ////联系人手机号码
          phone: mechanismData.userMobile,
        },
        userLogin: {
          //用户名
          name: mechanismData.loginName,
          //联系人座机电话
          landline: mechanismData.landline,
          //单位管理员头像
          avatar: mechanismData.avatar,
        },
        //手机短信验证码
        vcode: mechanismData.vcode,
        //签名
        token: mechanismData.token,
        bizToken: this.bizToken
      };
      return data;
  }


  checkMobile() {
    //验证手机号
    if (!this.isSend) return;
    const mobile = this.mechanismData.userMobile;
    if (!mobile.match(/^1[3-9][0-9]{9}$/)) {
      this.$message({
        message: '手机号有误',
        type: 'warning',
        duration: 1000,
        onClose: () => {
          this.mechanismData.userMobile = '';
        }
      });
      return false;
    }
    this.isSend = true
    this.sendSms();
  }

  //发送手机验证码
  sendSms() {
    if (!this.isSend) return;
    this.isSend = false;
    this.smsInterval = "发送中...";
    mechanismApi.sendVerifyCodeUnVerify({phone: '+86' + this.mechanismData.userMobile, template: 'register-company'}).then((r) => {
      if (r.data.result === 0) {
        this.mechanismData.token = r.data.data
        this.smsIntervalMethod();
      }else{
        this.smsInterval = "获取验证码";
        this.isSend = true;
      }
    });
  }

  smsIntervalMethod() {
    let smsIntervalTime = 60;
    let timer = setInterval(() => {
      if (smsIntervalTime <= 1) {
        clearInterval(timer);
        this.smsInterval = "获取验证码";
        this.isSend = true; // 重新回复点击发送功能的条件
      } else {
        smsIntervalTime -= 1;
        this.smsInterval = `${smsIntervalTime}秒后再发`;
      }
    }, 1000);
  }

  getDetectInfoEnhanced(callback: any){
    mechanismApi.getDetectInfoEnhanced(this.getRegisterData()).then((r) => {
        if(callback){
          callback(r.data);
        }
    });
  }

  queryResult(){
    // const timer = setInterval(() => {
    //   if(this.active != 3){
    //     clearInterval(timer);
    //   }
    const loading = this.$loading({
      text: '正在查询',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
      //查询结果
      this.getDetectInfoEnhanced((data: any) => {
        loading.close();
        this.registStatus = data.result;
        if(data.result === 0){
          this.registMsg = data.data;
        }else{
          this.registMsg = data.message;
        }
        this.active = 5;
        // setTimeout(() => {
        //   this.$router.push("/login");
        // }, 2000);
        // clearInterval(timer);
      });
    // }, 5000);
    // this.$once( 'hook:beforeDestroy' , () => { clearInterval(timer); });
  }

  checkVerifyUI(callback: any){
    if(!this.mechanismData.token){
      this.$message.warning("请先获取手机验证码！");
      return;
    }
    mechanismApi.checkVerifyUI({
      token: this.mechanismData.token,
      vcode: this.mechanismData.vcode
    }).then((r) => {
      if (r.data.result === 0) {
        if(callback){
          callback();
        }
      }
    });
  }


  detectAuth(callback: any) {
    const loading = this.$loading({
      text: '正在生成',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    userApi.detectAuth(this.mechanismData.idCard, this.mechanismData.clientName, this.mechanismData.idCardUp).then((r) => {
      loading.close();
      if (r.data.result === 0) {
        const {bizToken, url} = r.data.data;
        this.bizToken = bizToken;
        if(callback){
          callback(url);
        }
      }
    });
  }

  //地图选点
  changeMap(e: any) {
    this.map.visible = false;
    this.mechanismData.location = e.position.join(",");
    this.mechanismData.postalAddress = e.address;
  }

  showMap() {
    this.map.visible = true;
  }

  //是否是授权机构
  isAuthMechanism(){
    return this.mechanismData.types.indexOf("0006") > -1 || this.mechanismData.types.indexOf("0008") > -1;
  }
  handleRegionChange(value: any) {
    this.mechanismData.region = value.join(",").replace(/\s+/g, "");
  }
  // 身份证头像面上传
  handleIdCardUpSuccess(res: any) {
    if (res.result === 0) {
      this.mechanismData.idCardUp = res.data;
      this.ocrIdCardFinish = false;
      this.$message.success("上传成功");
    }
  }
  //身份证反面上传
  handleIdCardDownSuccess(res: any) {
    if (res.result === 0) {
      this.mechanismData.idCardDown = res.data;
      this.$message.success("上传成功");
    }
  }
  //授权委托书上传
  handleEmpowerSuccess(res: any) {
    if (res.result === 0) {
      this.empowerDialog.filePath = res.data;
      this.$message.success("上传成功");
    }
  }
  //营业执照 上传
  handleCorporateSuccess(res: any) {
    if (res.result === 0) {
      this.mechanismData.corporate = res.data;
      this.ocrLicenseFinish = false;
      this.$message.success("上传成功");
    }
  }
  //图片上传判断
  beforeImageUpload(file: any) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    if (!isJPG && !isPNG) {
      this.$message.error('上传图片只能是 JPG 或 PNG格式!');
    }
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      this.$message.error("上传大小不能超过 10MB");
      return false;
    }
    return (isJPG || isPNG);
  }
  download() {
    window.open(baseUrl + `/file/download-empower?legal=${this.mechanismData.userName}&orgName=${this.mechanismData.name}&agent=${this.mechanismData.clientName}&idCard=${this.mechanismData.idCard}`, '_blank');
  }
  logout() {
    this.$router.replace("/login");
  }

  openEmpowerDialog(){
    this.empowerDialog.filePath = this.mechanismData.empower;
    this.empowerDialog.visible = true;
  }
  closeDialog(){
    this.empowerDialog.filePath = "";
    this.empowerDialog.visible = false;
  }
  submitEmpowerDialog(){
    this.mechanismData.empower = this.empowerDialog.filePath;
    this.empowerDialog.visible = false;
  }
  goLogin(){
    this.$router.replace("/login");
  }
}
